import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

// Parse calendar values locally. Never use Date.parse/UTC for a business date.
export const bankRecDate = (value) => {
  if (value === null || value === undefined || value === "") return null;
  if (Array.isArray(value)) {
    const [year, month, day] = value;
    return bankRecDate(`${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`);
  }
  const date = typeof value === "string"
    ? dayjs(value, ["YYYY-MM-DD", "MM/DD/YYYY", "YYYY-MM-DD HH:mm:ss"], true)
    : dayjs(value);
  return date.isValid() ? date : null;
};

export const bankRecDateString = (value) => {
  const date = bankRecDate(value);
  if (value !== null && value !== undefined && value !== "" && !date) {
    throw new Error("Please enter a valid date.");
  }
  return date ? date.format("YYYY-MM-DD") : null;
};

// EnhancedTable emits browser-local picker timestamps; normalize them before HTTP.
export const bankRecDateParams = (params) => {
  const result = { ...params };
  ["reconcileDateSt", "date", "date1", "clearedDate", "dateFr", "dateTo"].forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(result, key)) {
      result[key] = bankRecDateString(result[key]);
    }
  });
  return result;
};
